import { Component, Input, inject } from '@angular/core';
import { CommonModule } from '@angular/common';
import { Router } from '@angular/router';
import { GoogleAnalyticsService } from '../../../services/google-analytics.service';
import { navigateToCatalogueAssetDetail } from '../../utils/catalogue-asset-detail-navigation.util';

export interface AssetCardData {
  id: string;
  title: string;
  provider?: string;
  organisation?: string;
  description?: string;
  tags?: string[];
  metadata?: {
    type?: string;
    format?: string;
    language?: string;
    modelType?: string;
    percentage?: number;
    date?: string;
  };
  badge?: {
    label: string;
    color?: 'public' | 'private' | 'personal' | 'new' | 'evaluation' | 'announced' | 'restricted';
  };
  likes?: number;
  views?: number;
  downloads?: number;
  isNew?: boolean;
  [key: string]: any; // Allow additional properties for flexibility
}

@Component({
  selector: 'app-asset-card',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './asset-card.component.html',
  styleUrl: './asset-card.component.scss',
})
export class AssetCardComponent {
  @Input() data!: AssetCardData;
  @Input() assetType: 'dataset' | 'model' | 'usecase' = 'dataset';
  /** Use 'challenge' for datasets/models in challenge detail – layout matches collection card (tag pill, meta row, metrics). */
  @Input() variant: 'challenge' | 'default' = 'default';
  /** When true (e.g. challenge preview), click does not navigate. */
  @Input() previewMode: boolean = false;

  private router = inject(Router);
  private googleAnalytics = inject(GoogleAnalyticsService);

  navigateToDetail(): void {
    if (this.previewMode) return;
    if (this.data.id && this.assetType === 'dataset') {
      this.googleAnalytics.trackDatasetClick(this.data.title ?? '', this.data.id);
      void navigateToCatalogueAssetDetail(this.router, 'dataset', this.data.id);
    } else if (this.data.id && this.assetType === 'model') {
      this.googleAnalytics.trackModelClick(this.data.title ?? '', this.data.id);
      void navigateToCatalogueAssetDetail(this.router, 'model', this.data.id);
    } else if (this.data.id && this.assetType === 'usecase') {
      this.router.navigate(['/usecase', this.data.id]);
    }
  }

  getDisplayTag(tag: string): string {
    // Replace PII with Personal for UI display only (case-insensitive)
    if (!tag) return tag;
    return tag.toUpperCase() === 'PII' ? 'Personal' : tag;
  }
}

